<template>
    <div class="cookies-banner" v-if="showCookiesBanner">
        <div class="title">
            {{ $t("home.cookies.we-respect-your-privacy") }}
        </div>
        <div class="cookies-banner-inner">
            <div v-if="showSettings" class="settings">
                <md-switch v-model="state.essential_storage" :disabled="1">
                    {{
                        $t("home.cookies.essential-description")
                    }}
                </md-switch>
                <md-switch v-model="state.analytics_storage">
                    {{
                        $t("home.cookies.analytics-description")
                    }}
                </md-switch>
                <md-switch v-model="state.ad_user_data">
                    {{
                        $t("home.cookies.ad-user-description")
                    }}
                </md-switch>
                <md-switch v-model="state.ad_personalization">
                    {{
                        $t("home.cookies.ad-personalization-description")
                    }}
                </md-switch>
            </div>
            <span v-else v-html="$t('home.cookies-info')" class="info" />
            <div class="cookies-choice-wrapper">
                <div class="cookies-choice-row" v-if="showSettings">
                    <a
                        class="cookies-choice cookies-choice-refuse"
                        @click="refuse"
                    >{{ $t("home.cookies.refuse-all") }}</a>
                    <a
                        class="cookies-choice cookies-choice-accept"
                        @click="accept"
                    >{{ $t("home.cookies.accept-all") }}</a>
                </div>
                <div class="cookies-choice-row" v-else>
                    <a
                        class="cookies-choice cookies-choice-refuse"
                        @click="refuse"
                    >{{ $t("home.cookies.refuse") }}</a>
                    <a
                        class="cookies-choice cookies-choice-accept"
                        @click="accept"
                        dusk="accept-cookies-button"
                    >{{ $t("home.cookies.accept") }}</a>
                </div>
                <div class="cookies-choice-row" v-if="showSettings">
                    <a
                        class="cookies-choice cookies-choice-save-parameters"
                        @click="saveSettings"
                    >{{ $t("home.cookies.save-preferences") }}</a>
                </div>
                <div class="cookies-choice-row" v-else>
                    <a
                        class="cookies-choice cookies-choice-parameters"
                        @click="showSettings = true"
                    >{{ $t("home.cookies.preferences") }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showCookiesBanner: false,
            showSettings: false,
            state: {
                essential_storage: true,
                analytics_storage: false,
                ad_user_data: false,
                ad_personalization: false,
            },
        };
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('app-traking')) {
            const appTracking = urlParams.get('app-traking');
            if (appTracking == 'true') {
                this.accept();
            } else {
                this.refuse();
            }
        } else {
            if (this.$cookies.isKey('cookies-consent-config')) {
                window.setConsentState(
                    this.$cookies.get('cookies-consent-config')
                );
            } else {
                this.showCookiesBanner = true;
            }
        }
    },
    methods: {
        accept() {
            this.setResponse({
                essential_storage: 'granted',
                analytics_storage: 'granted',
                ad_user_data: 'granted',
                ad_personalization: 'granted',
            });
        },
        refuse() {
            this.setResponse({
                essential_storage: 'denied',
                analytics_storage: 'denied',
                ad_user_data: 'denied',
                ad_personalization: 'denied',
            });
        },
        saveSettings() {
            this.setResponse({
                essential_storage: this.state.essential_storage
                    ? 'granted'
                    : 'denied',
                analytics_storage: this.state.analytics_storage
                    ? 'granted'
                    : 'denied',
                ad_user_data: this.state.ad_user_data ? 'granted' : 'denied',
                ad_personalization: this.state.ad_personalization
                    ? 'granted'
                    : 'denied',
            });
        },
        setResponse(state) {
            this.showCookiesBanner = false;
            this.$cookies.set(
                'cookies-consent-config',
                state,
                60 * 60 * 24 * 365,
                '/'
            );
            window.setConsentState(state);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~styles/_variables";
.cookies-banner {
	.title {
		font-size: 18px;
		font-weight: bold;
		@media (max-width: 1023px) {
			margin-bottom: 20px;
		}
	}
	position: fixed;
	bottom: 20px;
	left: 20px;
	right: 20px;
	padding: 20px;
	background-color: #f5f5f5;
	border-radius: 20px;
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
		0 2px 4px -2px rgba(0, 0, 0, 0.1);
	z-index: 100;
	.cookies-banner-inner {
		@media (min-width: 1024px) {
			display: flex;
		}
		align-items: center;
		.info {
			flex-grow: 1;
		}
		.settings {
			flex-grow: 1;
			display: flex;
			flex-direction: column;
		}
		.cookies-choice-wrapper {
			@media (max-width: 1023px) {
				margin-top: 20px;
			}
		}
		.cookies-choice-row {
			display: flex;
		}
		a.cookies-choice {
			margin: 5px 10px;
			flex-grow: 1;
			white-space: nowrap;
			text-align: center;
			padding: 10px;
			border-radius: 20px;
			height: 40px;
			font-size: 12px;
			font-weight: 500;
			&.cookies-choice-accept,
			&.cookies-choice-save-parameters {
				background-color: $primary-color;
				color: white;
				border: solid $primary-color 1px;
			}
			&.cookies-choice-refuse,
			&.cookies-choice-parameters {
				border: solid $primary-color 1px;
			}
			cursor: pointer;
			&:hover {
				background-color: $primary-color-dark;
				color: white;
				border: solid $primary-color-dark 1px;
			}
			transition: background-color 300ms, border 300ms;
		}
	}
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/CookiesInfo.vue